import { ExamCreatePage } from "@/features/learning-content/pages/ExamCreate";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const ExamCreate: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <ExamCreatePage />
      </Box>
    </Stack>
  );
};

export default ExamCreate;
